import { render } from "./RigaIvaPianoFatturazione.vue?vue&type=template&id=4c51fbc8&ts=true"
import script from "./RigaIvaPianoFatturazione.vue?vue&type=script&lang=ts"
export * from "./RigaIvaPianoFatturazione.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__